import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '../Directives/directives.module';
import { SharedPipesModule } from '../Pipes/shared-pipes.module';
import { AceBadgeComponent } from './Badge/badge.component';
import { AceBannerComponent } from './Banner/banner.component';
import { AceButtonGroupComponent } from './Button-Group/buttonGroup.component';
import { AceButtonComponent } from './Button/button.component';
import { AceButtonModule } from './Button/button.module';
import { AceCardModule } from './Card/card.module';
import { AceDropdownComponent } from './Dropdown/dropdown.component';
import { AceIconComponent } from './Icon/icon.component';
import { AceIconModule } from './Icon/icon.module';
import { AceLoaderComponent } from './Loader/loader.component';
import { AceSelectComponent } from './Select/select.component';
import { AceSelectModule } from './Select/select.module';
import { AceSimpleTableComponent } from './Simple-Table/simpleTable.component';
import { AceSimpleTableModule } from './Simple-Table/simpleTable.module';
import { AceTabContentComponent } from './Tab-Set/Tab-Content/tabContent.component';
import { AceTabSetComponent } from './Tab-Set/tabSet.component';
import { AceTabSetModule } from './Tab-Set/tabSet.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DirectivesModule,
        SharedPipesModule,
        AceButtonModule,
        AceCardModule,
        AceSelectModule,
        AceIconModule,
        AceTabSetModule,
        AceSimpleTableModule,
        AceLoaderComponent
    ],
    declarations: [
        AceBadgeComponent,
        AceBannerComponent,
        AceButtonGroupComponent,
        AceDropdownComponent
    ],
    exports: [
        AceBadgeComponent,
        AceBannerComponent,
        AceButtonGroupComponent,
        AceDropdownComponent,
        AceIconComponent,
        AceLoaderComponent,
        AceSelectComponent,
        AceSimpleTableComponent,
        AceTabSetComponent,
        AceTabContentComponent,
        AceButtonComponent
    ]
})
export class AceModule {

}
